<template>
  <div class="">

      <div class="modal fade" id="modal-edit-customer" data-backdrop="static" focus="true" data-keyboard="false" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                  <!-- {{ itemSku }} Incoming Purchase Orders -->{{ customerEdit.company_name }}
              </h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
            </div>
            <div class="modal-body">

                <form>
                    <div class="mb-3">
                        <label for="customerCompany" class="form-label">Company Name</label>
                        <input type="email" class="form-control" id="customerCompany" aria-describedby="customerCompany" v-model="customerEdit.company_name"  disabled>
                    </div>
                    <div class="mb-3">
                        <label for="customerDomain" class="form-label">Company Website</label>
                        <input type="email" class="form-control" id="customerDomain" aria-describedby="customerDomain" v-model="customerEdit.domain">
                    </div>
                    <div class="mb-3">
                        <label for="customerCompany" class="form-label">Contact Name</label>
                        <input type="email" class="form-control" id="customerContact" aria-describedby="customerContact" v-model="customerEdit.contact_name">
                    </div>
                    <div class="mb-3">
                        <label for="customerEmail" class="form-label">Email address</label>
                        <input type="email" class="form-control" id="customerEmail" aria-describedby="customerEmail" v-model="customerEdit.email">
                    </div>
                    <div class="mb-3">
                        <label for="customerPhone" class="form-label">Phone</label>
                        <input type="text" class="form-control" id="customerPhone" v-model="customerEdit.phone">
                    </div>
                    <div class="mb-3 row justify-content-center">
                        <div class="col text-center">
                            <a target="_blank" role="button" type="button" class="btn btn-sm btn-secondary" :href="'https://app.hubspot.com/contacts/21619105/contact/' + customerEdit.hubspot_contact_id ">View Contact On Hubspot</a>
                        </div>
                        <div class="col text-center">
                            <a target="_blank" role="button" type="button" class="btn btn-sm btn-secondary" :href="'https://app.hubspot.com/contacts/21619105/company/' + customerEdit.hubspot_company_id ">View Company On Hubspot</a>
                        </div>
                    </div>
                    <hr>
                    <div class="mb-3">
                        <label for="customerStreet" class="form-label" :class="!customerEdit.street1 ? 'text-danger' : ''">Shipping Address</label>
                        <input type="text" class="form-control" :class="!customerEdit.street1 ? 'border-danger' : ''" id="customerStreet" v-model="customerEdit.street1">
                    </div>
                    <!-- <div class="mb-3">
                        <label for="customerStreet2" class="form-label">Street 2</label>
                        <input type="text" class="form-control" id="customerStreet2" v-model="customerEdit.street2">
                    </div> -->
                    <div class="mb-3">
                        <label for="customerCity" class="form-label" :class="!customerEdit.city ? 'text-danger' : ''">Shipping City</label>
                        <input type="text" class="form-control" :class="!customerEdit.city ? 'border-danger' : ''" id="customerCity" v-model="customerEdit.city">
                    </div>
                    <div class="mb-3">
                        <label for="customerCity" class="form-label" :class="!customerEdit.state ? 'text-danger' : ''">Shipping State</label>
                        <input type="text" class="form-control" :class="!customerEdit.state ? 'border-danger' : ''" id="customerCity" v-model="customerEdit.state">
                    </div>
                    <div class="mb-3">
                        <label for="customerZip" class="form-label" :class="!customerEdit.postal_code ? 'text-danger' : ''">Shipping Postal Code</label>
                        <input type="text" class="form-control" :class="!customerEdit.postal_code ? 'border-danger' : ''" id="customerZip" v-model="customerEdit.postal_code">
                    </div>
                    <div class="mb-3">
                        <label for="customerCountry" class="form-label" :class="!customerEdit.country ? 'text-danger' : ''">Shipping Country</label>
                        <input type="text" class="form-control" :class="!customerEdit.country ? 'border-danger' : ''" id="customerCountry" v-model="customerEdit.country">
                    </div>

                  
                </form>
    <!--             <div class="form-group row">
                  <div class="col-md-6">
                        <label for="rep" class="col-sm-auto col-form-label fw-bold">Sales Rep</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="rep" v-model="orderEdit.user">
                        </div>
         
                        <label for="ssID" class="col-sm-auto col-form-label fw-bold">Shipstation ID</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="ssID" v-model="orderEdit.shipstation_id">
                        </div>

                        <label for="ssStatus" class="col-sm-auto col-form-label fw-bold">Shipstation Status</label>
                      <div class="col-sm-auto">
                        <input type="text" readonly class="form-control-plaintext" id="ssStatus" v-model="orderEdit.shipstation_status">
                      </div>

                      </div>
                      <div class="col-md-6">
                        <label for="closeDate" class="col-sm-auto col-form-label fw-bold">Close Date</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="closeDate" v-model="orderEdit.closed_at">
                        </div>
                
                        <label for="hubspotID" class="col-sm-auto col-form-label fw-bold">Hubspot Deal</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="hubspotID" v-model="orderEdit.hubspot_id">
                        </div>

                        <label for="hubspotStatus" class="col-sm-auto col-form-label fw-bold">Hubspot Status</label>
                      <div class="col-sm-auto">
                        <input type="text" readonly class="form-control-plaintext" id="hubspotStatus" v-model="orderEdit.hubspot_status">
                      </div>

                      </div>
                    </div>
                    <hr>
                    <div class="form-group row">
                        <div class="col-md-6">
                            <label for="contact" class="col-sm-auto col-form-label fw-bold">Customer</label>
                            <div class="col-sm-auto">
                              <input type="text" readonly class="form-control-plaintext" id="contact" v-model="orderEdit.contact">
                            </div>
                        </div>
                        <div class="col-md-6">

                        </div>
                    </div> -->


              
            </div>
            <!-- Modal Actions -->
            <div class="modal-footer border-none">
              <button type="button" class="btn btn-light" @click="closeModal">
                Close
              </button>
              <button type="submit" class="btn btn-light text-white" style="background-color:#ff7a59;" @click="updateCustomer">Save</button>
            </div>
          </div>
        </div>
      </div>

      <!-- end of modal -->
  </div>
</template>

<style lang="css">

</style>

<script>
  import moment from 'moment'
  export default {
    props:{
        onSaveCallback: {
        type: Function,
        default: function () {return true;}
      },
      customer: {
        type: [Object,Array]
      },
      origin: {
        type: String
      }
    },
    data() {
      return {
        customerEdit: [],
        errors: [],
        showing_modal: false,
        updating:false,
      };
    },
    created() {
      // runs when the component is created
      // this.alias();
      Bus.$on('editCustomerModalShow', () => {
        this.customerEdit = this.customer;
        // this.getPurchaseOrders();
        this.showModal();
      });
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {
      
      // sum: function(items, prop){
      //   return items.reduce( function(a, b){
      //     return a + b[prop];
      //   }, 0);
      // },
      // orderedSum(){
      //   return this.sum(this.orders,'quantity_ordered');
      // },
      
    },
    methods: {
      closeModal(){
        $('#modal-edit-customer').modal('hide');
        this.showing_modal = false;
      },
      showModal(){
        $('#modal-edit-customer').modal('show');
        this.showing_modal = true;
      },
      updateCustomer(){
        this.updating = true;
        axios({
          method: 'put',
          url: '/api/companies/' + this.customerEdit.id,
          data: this.customerEdit,
        }).then((res)=>{
            this.successfulSave();
            this.updating = false;
            this.closeModal();
            // this.saved = true;
            // Bus.$emit('newOacAlert', {text: 'Thank you for requesting a new feature!', type: 'success'});
        }).catch((error) => {
          console.log(error);
          // this.errors.push({msg: error.response.data.message });
          // Bus.$emit('newOacAlert', {text: error.response.data.message, type: 'danger'});
        });
    },
    successfulSave(){
        this.onSaveCallback();
    },
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
    },
    watch:{
       // orderEdit(val) {
       //     this.orderEdit.closed_at = this.$options.filters.moment(val);
       //  },
    }
  }
  // Bus.$emit('updateUser');
</script>